// src/app/stores/orderStore.ts
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { getOutlets } from "../services/OutletService";


export interface State {
  id: number;
  name: string;
  is_active: boolean;
}

export interface Outlets {
  id: number;
  name: string;
  email: string;
  org_id: number;
  mobile: string;
  secondary_mobile: string;
  pan_number: string;
  gst_number: string;
  shop_license: string;
  fssai_number: string;
  license_registration_number: string;
  lat: string;
  long: string;
  shipping_addressline1: string;
  shipping_addressline2: string;
  shippingpincode: string;
  shippingcity:string;
  billingcity:string;
  billing_addressline1: string | null;
  billing_addressline2: string | null;
  billingpincode: string | null;
  opening_time: string;
  closing_time: string;
  lunch_time: string | null;
  prefferable_delivery_slot: string | null;
  pin_code: string | null;
  land_mark: string;
  profile_setup_status: number;
  shop_board_attachment: string | null;
  license_attachment: string | null;
  pan_attachment: string | null;
  storey: number;
  is_lift_available: number;
  is_active: boolean;
  shippingState: State;
  billingState: State | null;
  created_at: string;
  updated_at: string | null;
  created_by: string;
  updated_by: string | null;
}

export default class Outletstore {
  outlets: Outlets[] = [];
  selectedOutlet: Outlets | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  loadOutlets = async () => {
    try {
      const res = await getOutlets();
      if (res && res.status === "success") {
        runInAction(() => {
          this.outlets = res.data;
          this.selectedOutlet = res.data[0] || null;
        });
      }
    } catch (error) {
      toast.error("Could not load outlets");
    }
  };

  setSelectedOutlet = (outlet: Outlets) => {
    this.selectedOutlet = outlet;
  };
}
